import React from 'react';
import { v4 } from 'uuid';
import { connect } from 'react-redux';
import { FormSection, reduxForm, formValueSelector, change } from 'redux-form';

import { ContentSet } from 'components/Shared/Scaffolding';
import SettingsGroup, { SettingsHelper } from 'components/Shared/SettingsGroup';
import LocationInput from 'components/Shared/LocationInput';
import { TextButton } from 'components/Shared/Buttons';
import IconSettings from 'components/MarkerSettings/IconSettings';
import { MARKER_TYPE } from 'components/MarkerSettings/IconOptions';
import { Input, ButtonSet } from 'components/Shared/Forms';
import { requiredLocation, onSubmitFail } from 'utils/validation';
import { saveMarker, formName } from 'modules/markers';
import { getActiveMarker } from 'modules/navigation/activeMarker';

const MarkerForm = ({ handleSubmit, icon, onCancel }) => {
    const { type, color, width, height, anchorX, anchorY, image } = icon || {};
    return (
        <form onSubmit={handleSubmit}>
            <ContentSet spacing="40px">
                <ContentSet spacing="40px">
                    <SettingsGroup name="Name" description="Enter a name for this marker">
                        <Input name="name" width="100%" required />
                    </SettingsGroup>
                    <SettingsGroup
                        name="Location"
                        description="Please search for a location or enter a latitude and longitude"
                    >
                        <SettingsHelper>
                            Click anywhere on the map to place a marker or search below for your location. Once placed,
                            you can click and drag the marker to fine-tune its position.
                        </SettingsHelper>
                        <FormSection name="location" component={LocationInput} />
                    </SettingsGroup>
                    <SettingsGroup name="Icon" description="Select the type of icon you want to use for this marker">
                        <IconSettings
                            image={image}
                            type={type}
                            color={color}
                            size={{ width, height }}
                            anchor={{ x: anchorX, y: anchorY }}
                        />
                    </SettingsGroup>
                </ContentSet>
                <ButtonSet>
                    <TextButton primary type="submit">
                        Apply Changes
                    </TextButton>
                    <TextButton secondary type="button" onClick={onCancel}>
                        Cancel
                    </TextButton>
                </ButtonSet>
            </ContentSet>
        </form>
    );
};

const getDefaultValues = (id) => ({
    id,
    icon: {
        type: MARKER_TYPE.DEFAULT,
        styledMarkerId: 0,
        color: '#f44336',
        size: 36,
        width: 36,
        height: 36,
        anchorX: 18,
        anchorY: 36,
    },
});

// Allow other components to change our location in the form
const setActiveMarkerLocation = (location) => change(formName, 'location', location);

const validate = ({ location }) => ({
    location: requiredLocation(location),
});

const onSubmit = (values, dispatch, props) => {
    dispatch(saveMarker(values));
    props.onClose();
};

const formValue = formValueSelector(formName);
const mapStateToProps = (state) => ({
    initialValues: getActiveMarker(state) || getDefaultValues(v4()),
    icon: formValue(state, 'icon'),
});

export { setActiveMarkerLocation };
export default connect(mapStateToProps)(reduxForm({ form: formName, validate, onSubmit, onSubmitFail })(MarkerForm));
